import { useEffect, useState } from "react";

// Breakpoint unico para "modo mobile" em todo o painel principal -- mesmo
// valor (720px) ja usado no modulo de Checklist (ver checklist/checklist.css)
// para manter os dois comportamentos consistentes entre si.
export const MOBILE_BREAKPOINT = 720;

// Hook simples baseado em matchMedia (reage a resize/rotacao de tela em
// tempo real, sem precisar de listener manual de "resize" + debounce).
export default function useIsMobile(breakpoint = MOBILE_BREAKPOINT) {
  const [isMobile, setIsMobile] = useState(() => {
    if (typeof window === "undefined" || !window.matchMedia) return false;
    return window.matchMedia(`(max-width: ${breakpoint}px)`).matches;
  });

  useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) return;
    const mq = window.matchMedia(`(max-width: ${breakpoint}px)`);
    const onChange = () => setIsMobile(mq.matches);
    onChange();
    if (mq.addEventListener) mq.addEventListener("change", onChange);
    else mq.addListener(onChange);
    return () => {
      if (mq.removeEventListener) mq.removeEventListener("change", onChange);
      else mq.removeListener(onChange);
    };
  }, [breakpoint]);

  return isMobile;
}
